import { type QueryHookOptions, useQuery } from "@apollo/client";
import { UserQuery } from "../graphql/queries";
import type { UserQueryType } from "@/types/graphql/partner.generated";

export const useUserQuery = (options?: QueryHookOptions<UserQueryType>) => {
  return useQuery<UserQueryType>(UserQuery, options);
};
